<script lang="ts">
  import { getContext } from "svelte";
  import { DropdownRadioGroupContext, type RadioGroup } from "../dropdown-menu";

  const { value: internalValue, item } = getContext<RadioGroup>(DropdownRadioGroupContext);

  export let value: string;
  export let closeOnSelect: boolean = true;
  export let disabled: boolean = false;
</script>

<div class={$$restProps.class} use:item={{ value, closeOnSelect, disabled }}>
  <slot checked={$internalValue === value} />
</div>
